import { useEffect } from 'react';
import styled from 'styled-components/macro';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { H3, Label3 } from '../Text';
import useMarkets, { Market } from '../../contexts/MarketsContext';

import { Dropdown } from '../Dropdown';

const MarketOption = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.7rem 0.95rem;
`;

const SelectedOption = styled.div`
  display: flex;
  flex-direction: row;
`;

const SelectedOptionText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 8rem;
`;

const Flag = styled.img`
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 1.125rem;
  margin-right: 0.625rem;
`;

interface MarketSelectorProps {
  className?: string;
}

export function MarketSelector({ className }: MarketSelectorProps) {
  const params = useParams();
  const navigate = useNavigate();
  const { marketList, setSelectedMarketId, selectedMarket } = useMarkets();
  const { t } = useTranslation();

  useEffect(() => {
    if (params.id === undefined) {
      navigate('/trade/0');
    }
  }, [marketList, params, navigate]);

  useEffect(() => {
    if (params && setSelectedMarketId && params.id !== selectedMarket?.id && params.id) {
      setSelectedMarketId(params.id);
    }
  }, [params, setSelectedMarketId, selectedMarket]);

  return (
    <Dropdown<Market>
      options={marketList}
      selected={selectedMarket}
      className={className}
      renderOption={(market) => (
        <MarketOption>
          <Flag src={market?.img} />
          <H3>{market?.name}</H3>
        </MarketOption>
      )}
      renderSelected={(market) => (
        <SelectedOption>
          <Flag src={market?.img} />
          <SelectedOptionText>
            <Label3>{t('Market')}</Label3>
            <H3>{market?.name}</H3>
          </SelectedOptionText>
        </SelectedOption>
      )}
      onChange={(market: Market) => {
        navigate(`/trade/${market.id}`, { replace: true });
      }}
      size="l"
      hoverEnabled
    />
  );
}

MarketSelector.defaultProps = {
  className: '',
};
